import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { GoogleDateInterface, SpecialHoursStatus, TimeOfDayInterface } from '@vendasta/listing-products';
import { format } from 'date-fns';

import { getLocale } from '@vendasta/galaxy/utility/locale';
import {
  SpecialHoursDateTimeInterface,
  SpecialHoursTimeSpanInterface,
} from '../../special-hours/business-hours.interface';

@Component({
  selector: 'forms-special-hours-display',
  templateUrl: './special-hours-display.component.html',
  styleUrls: ['./special-hours-display.component.scss'],
  standalone: false,
})
export class SpecialHoursDisplayComponent implements OnInit {
  @Input() specialDateTimeSpan: SpecialHoursDateTimeInterface;
  @Input() control: UntypedFormControl;

  isClosed = false;
  isOpen = false;
  displaySelectedDate: string;
  displayTimeSpan: SpecialHoursTimeSpanInterface[];

  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.displaySelectedDate = this.displayDate(this.specialDateTimeSpan.date);
    this.displayTimeSpan = this.specialDateTimeSpan.timeSpan;
    this.isOpen = this.specialDateTimeSpan.status === SpecialHoursStatus.SPECIAL_HOURS_STATUS_OPEN;
    this.isClosed = this.specialDateTimeSpan.status === SpecialHoursStatus.SPECIAL_HOURS_STATUS_CLOSED;
  }

  displayDate(date: GoogleDateInterface): string {
    if (!date) {
      return '';
    }

    const year = date.year || 0;
    const month = date.month || 1;
    const day = date.day || 1;

    const dateObj = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
    return format(dateObj, 'PPP', { locale: getLocale() });
  }

  displayTime(time: TimeOfDayInterface): string {
    if (!time) {
      return '';
    }

    const hours = time.hours || 0;
    const minutes = time.minutes || 0;
    const now = new Date();
    now.setHours(hours, minutes);

    const formatter = Intl.DateTimeFormat(getLocale().code, { timeStyle: 'short' });

    return formatter.format(now);
  }

  isOpen24Hours(start: string, end: string): boolean {
    return start === end;
  }
}
